import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "month-picker" }
const _hoisted_2 = { class: "month-picker__month" }

import IconButton from "./IconButton.vue";

interface MonthPickerProps {
  label?: string;
}

interface MonthPickerEmits {
  (e: "prev"): void;
  (e: "next"): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MonthPicker',
  props: {
    label: {}
  },
  emits: ["prev", "next"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(IconButton, {
      "icon-name": "material-symbols:chevron-left",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('prev')))
    }),
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label), 1),
    _createVNode(IconButton, {
      "icon-name": "material-symbols:chevron-right",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('next')))
    })
  ]))
}
}

})